interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  {name: 'zoopim', src: 'https://v2.zopim.com/?5mGs9Y0f4fsgAM6lCyzO0tL0BIa8X6xs'}
];
